module.exports = __webpack_public_path__ + "img/pantalla-1-3.7f8fb6ea.png";